export default function() {
  return document.body.getAttribute('data-currency');
}
